/* eslint-disable */
import Swiper from "swiper/bundle";
/* eslint-enable */

class SliderGallery {
	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.sliderGallerySections =
			this.sectionsContainer.getElementsByClassName("slider-gallery");
		if (this.sliderGallerySections[0]) {
			this.init();
		}
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		Array.from(this.sliderGallerySections).forEach((section) =>
			this.initSlider(section)
		);
	}

	initSlider(section) {
		const swiperContainer = section.querySelector(".swiper-container");
		const swiperButtonPrev = section.querySelector(".swiper-button-prev");
		const swiperButtonNext = section.querySelector(".swiper-button-next");
		this.swiperInstance = new Swiper(swiperContainer, {
			// Optional parameters
			grabCursor: true,
			loop: false,
			slidesPerView: 1.2,
			spaceBetween: 24,

			// Responsive
			breakpoints: {
				992: {
					slidesPerView: "auto",
				},
			},

			// Navigation arrows
			navigation: {
				nextEl: swiperButtonNext,
				prevEl: swiperButtonPrev,
			},
			on: {
				/* eslint-disable */
				init: function () {
					const swiper = section.querySelector(".swiper-container").swiper;
					const sliderNavigation = section.querySelector(".slider-navigation");
					// disable resize items number
					const disableSwiper = () => {
						swiper.disable();
						swiper.el.classList.add("disable-swiper");
						if (sliderNavigation) {
							sliderNavigation.classList.add("disable-swiper");
						}
						if (swiper.slides.length == 2) {
							swiper.el.classList.add("disable-swiper__items");
						} else if (swiper.slides.length == 1) {
							swiper.el.classList.add("disable-swiper__item");
						} else {
							swiper.el.classList.remove("disable-swiper__items");
							swiper.el.classList.remove("disable-swiper__item");
						}
					};
					const enableSwiper = () => {
						swiper.enable();
						swiper.el.classList.remove("disable-swiper");
						if (sliderNavigation) {
							sliderNavigation.classList.remove("disable-swiper");
						}
					};
					const getWidth = () => {
						var w = window.innerWidth;
						if (w >= 768 && swiper.slides.length < 3) {
							swiper.el.classList.add("disable-swiper__disable-navigation");
						} else if (swiper.slides.length == 1) {
							disableSwiper();
						} else if (swiper.slides.length == 2) {
							swiper.el.classList.add("disable-swiper__disable-navigation");
						} else {
							enableSwiper();
						}
					};
					window.addEventListener("resize", getWidth);
					getWidth();
				},
			},
		});
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default SliderGallery;
